import { FC } from "react";
import Link from "next/link";
import { Container } from "@/components/ui/container";
import S from "./index.module.scss";

type ErrorProps = {
  code?: number | string;
  text?: string;
};

const Error: FC<ErrorProps> = ({ code, text = "Этой страницы\nне существует" }) => {
  const rawCode = String(code ?? 404);
  const displayCode = `${rawCode[0]}:${rawCode.slice(1)}`;
  const textLines = text.split("\n");

  return (
    <section className={S.errorSection}>
      <p className={S.code}>{displayCode}</p>
      <Container className={S.container}>
        <div className={S.content}>
          <h1 className={S.title}>
            {textLines.map((line, index) => (
              <span key={`${line}-${index}`}>{line}</span>
            ))}
          </h1>
          <Link href="/" className={S.homeLink}>
            На главную
          </Link>
        </div>
      </Container>
    </section>
  );
};

export default Error;
